import {FETCH_USER_ID} from "./index" 

export const setUserID = (payload) => {
    return {
      type: FETCH_USER_ID,
      payload: payload
    };
  };